import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Dispersion } from 'src/app/shared/models/dispersions';
import { Invoice } from 'src/app/shared/models/invoice';
import { DispersionsService } from 'src/app/shared/services/dispersions.service';
import { UtilitiesService } from 'src/app/shared/services/utilities.service';
import { CompaniesService } from 'src/app/shared/services/companies.service';

@Component({
  selector: 'app-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.scss']
})
export class DispersionDetailComponent implements OnInit {
  _subscriptions: Subscription[] = [];
  dispersion: Dispersion;
  udta: any;
  idInvoice : string;

  constructor(
    private utilitiesService: UtilitiesService,
    private dispersionsService: DispersionsService,
    private companiesService: CompaniesService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    if (this.route.snapshot.params['id']) {
      this._subscriptions.push(
        this.dispersionsService.getDispersion(this.route.snapshot.params['id']).subscribe(dispersion => {
          this.dispersion = dispersion;
        })
      );
    } else {
      this.router.navigate([`/dash/dispersions`]);
    }
    this.udta = this.utilitiesService.getUserData();
    console.log(this.udta);

  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this._subscriptions.forEach((sub) => sub.unsubscribe);
  }
}
